import React from 'react';
import { StatusConfig } from '../hooks/useGoalStatus';
import { UserSelectorAvatar } from '@/shared/components/user-selector/UserSelectorAvatar';
import { IssueAssignee, IssueVisibility } from '@momentum/types';
import { VisibilityBadge } from '@/features/goals/components/VisibilityBadge';

interface GoalCardHeaderProps {
  title: string;
  description?: string;
  statusConfig: StatusConfig;
  creator: IssueAssignee;
  visibility?: IssueVisibility;
  onShowView: () => void;
}

export const GoalCardHeader: React.FC<GoalCardHeaderProps> = ({
  title,
  description,
  creator,
  visibility,
  onShowView,
}) => {
  const creatorFullName = `${creator.personalInfo.firstName} ${creator.personalInfo.lastName}`;

  return (
    <div className="flex items-start gap-3 flex-1 min-w-0">
      {/* Title and Description */}
      <div className="flex-1 min-w-0">
        <div
          className="flex items-center gap-2 cursor-pointer"
          onClick={onShowView}
        >
          <UserSelectorAvatar
            fullName={creatorFullName}
            imageUrl={creator.personalInfo.imageUrl}
            size="md"
            variant="neutral"
          />
          {/* <StatusIcon className={cn('h-5 w-5', statusConfig.iconColor)} /> */}
          <h3 className="text-base font-semibold text-gray-900 leading-snug">
            {title}
          </h3>
          {visibility !== IssueVisibility.PUBLIC && (
            <VisibilityBadge
              visibility={visibility ?? IssueVisibility.PRIVATE}
              size="md"
            />
          )}
        </div>
        {description && (
          <p
            className="text-sm text-gray-600 mt-1.5 leading-relaxed cursor-pointer"
            onClick={onShowView}
          >
            {description}
          </p>
        )}
      </div>
    </div>
  );
};
